import Link from 'next/link';

import { getArtboardOptions } from '@repo/editor/src/utils/multiArtboards';
import { withEventScope } from '@repo/event-processor';

import { getSrcSetUrl, srcSetToImage } from 'components/utilities/srcSetUtils';
import {
  buildEditorUrlWithTemplateParams,
  getTemplateSEOName,
  getTemplateSEOObjectName,
} from 'global/urlUtils';

import { ImageWrapper, Box, Image } from './styles';
import { PreviewProps } from './types';

/**
 * render the preview of a template
 */
const Preview = ({
  template,
  isNewsfeed,
  canClick,
  onClick,
  width,
}: PreviewProps) => {
  let imgHeight;
  let imgWidth;
  const artboardOptions = getArtboardOptions(template.state);
  if (width && artboardOptions?.height) {
    imgWidth = width - 48; // 48px is horizontal padding
    const rawHeight = Math.floor(
      (artboardOptions.height / artboardOptions.width) * imgWidth
    );

    // Account for elements that are too narrow both vertically or horizontally
    // height is constrained to be in the range [50% * width, 720]
    imgHeight = Math.min(Math.max(0.5 * imgWidth, rawHeight), 720);
  }

  return (
    <Link
      legacyBehavior
      passHref
      href={buildEditorUrlWithTemplateParams({ id: template.id })}
    >
      <ImageWrapper
        canClick={canClick}
        isNewsfeed={isNewsfeed}
        target="_blank"
        onClick={onClick}
      >
        <Box isNewsfeed={isNewsfeed}>
          <Image
            alt={getTemplateSEOName(template)}
            // @ts-expect-error FixMe color issue
            backgroundColor={artboardOptions.fill}
            imgHeight={imgHeight}
            isNewsfeed={isNewsfeed}
            isPortrait={artboardOptions?.height > artboardOptions?.width}
            // NOTE: if this is ever changes please update `structuredSrc` in `pages/[slug]/[postId].js`
            srcSet={srcSetToImage(
              getSrcSetUrl(template.templatePreviewObjectName, {
                seoObjectName: getTemplateSEOObjectName(template) || undefined,
                width: 720,
                height: 720,
              })
            )}
          />
        </Box>
      </ImageWrapper>
    </Link>
  );
};

export default withEventScope(Preview, { module: 'designPostPreview' });
